export default "__VITE_ASSET__EtHOs8mI__"